import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=833cd032&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('833cd032')) {
      api.createRecord('833cd032', component.options)
    } else {
      api.reload('833cd032', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=833cd032&", function () {
      api.rerender('833cd032', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/Pagination.vue"
export default component.exports